var Stalker = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_stalker',
		toggle_nav: true,
		toggle_nav_duration: 500,
		toggle_nav_delta: 200,
		toggle_nav_element: null,
		double_nav: false
	},

	initialize: function (options) {
		this.setOptions(options);
		this._stalkers = document.getElements('.w_stalker_element');
		this.build();
	},

	build: function () {
		var self = this;
		this._element = document.getElement('.w_stalker');

		if (!this._element) {
			return;
		}
		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('touch_support');
		}

		this.stalkerHeight = this._element.getSize().y;

		this.persist_nav = this._element.getElement('.persist_nav');
		if (this.persist_nav && this.options.double_nav && document.body.getScroll().y > this.stalkerHeight) {
			this.persist_nav.setStyle('display', 'block');
		}

		this._container = this._element.getElement('.w_stalker_container');
		this.side_bar = document.getElement('.cr_side_bar');
		this._header_members_notification = document.getElement('.header_cont .members_center_notification');
		this._walkers = [];

		this._stalkers.each(function (_el) {
			if (_el.hasClass('_no_clone')) {
				self.create_wrapper(_el);
				self._walkers.push(_el);
			} else if (_el.hasClass('thead')) {
				self.add_stalker_thead(_el);
			} else {
				self._container.adopt(_el.clone());
			}
		});

		this.isDown = false;// by default element hasn't _down class
		this.add_jump_links();
		this.add_nav();
		this.add_inactive_message();
		this.add_burger_menu_bldg();
		if (this.options.toggle_nav) {
			this.add_scroll();
		}
		this.show_stalker();

		if (Core.is_touch_supported()) {
			this._element.addEvents({
				'focus:relay("input[type="text"], textarea")': function (e, _el) {
					self._active_input = _el;
				},
				'blur:relay("input[type="text"], textarea")': function () {
					self._active_input = null;
				}
			});

			window.addEvents({
				'touchstart': function (e) {
					if (self._active_input) {
						self._active_input.blur();
					}
				}
			});
		}

		// Add GLOBAL event listener (jquery and mootools)
		document.addEventListener("adjust_stalker", function (e) {
			if (self.side_bar) {
				self.adjust_side_bar();
			}
		});

		var resendEmailValidationLink = this._element.getElement('.resend-validation-link');
		var resendEmailValidationMessage = this._element.getElement('.message-email-sent');
		if (resendEmailValidationLink) {
			resendEmailValidationLink.addEvent('click', function () {
				new Remote({
					rpc: $(this).getAttribute('data-rpc'),
					onSuccess: function () {
						resendEmailValidationLink.hide();
						if (resendEmailValidationMessage) {
							resendEmailValidationMessage.show();
						}
					}
				});
			});
		}

		// Toggle nav on hover
		let toggleNav = (hoverBranding, hoverMenu, hoverTrigger) => {
			let stalker = this._element.querySelector('.main');
			let mainNavWrapper = this._element.querySelector('.main_nav_wrapper');
			if (stalker && mainNavWrapper) {
				if (hoverBranding || hoverMenu || hoverTrigger) {
					// show menu
					this._element.addClass('_show_menu');
				} else {
					// hide menu
					this._element.removeClass('_show_menu');
				}
			}
		};

		let hoverBranding = false;
		let hoverMenu = false;
		let branding = this._element.querySelector('.branding');
		if (branding) {
			branding.addEvents({
				'mouseover': () => {
					hoverBranding = true;
					toggleNav(hoverBranding, hoverMenu);
				},

				'mouseleave': () => {
					hoverBranding = false;
					toggleNav(hoverBranding, hoverMenu);
				}
			});
		}

		let mainNav = this._element.querySelector('.main_nav_wrapper_container');
		if (mainNav) {
			mainNav.addEvents({
				'mouseover': () => {
					hoverMenu = true;
					toggleNav(hoverBranding, hoverMenu);
				},

				'mouseleave': () => {
					hoverMenu = false;
					toggleNav(hoverBranding, hoverMenu);
				}
			});
		}
	
	},

	add_jump_links: function () {
		this.jump_links = this._element.getElements('.scroll_to');
		if (this.jump_links.length == 0) {
			return;
		}

		this.jump_targets = document.getElements('a.scroll_target');

		var targets_name = [];

		if (this.jump_targets.length > 0)
			this.jump_targets.each(function (_target) {
				targets_name.push(_target.getAttribute('name'));
			});

		this.offset = 100;

		var tmp_links = [];
		var self = this;
		this.jump_links.each(function (_link) {
			var link_target = _link.getAttribute('href', 2).split('#')[1];

			if (targets_name.indexOf(link_target) == -1 && !self._element.hasClass("_bdw")) {
				_link.getParent().destroy();
			} else {
				tmp_links.include(_link);
			}
		});

		if (tmp_links.length == 0) {
			return;
		}

		this.jump_links = tmp_links;

		// check if ScrollToElement is defined
		if (typeof (ScrollToElement) === 'function') {
			new ScrollToElement(this.jump_links, {
				offset_y: -this.offset + 5,
			});
		}

		this.refresh_DOM_height();
	},

	add_nav: function () {
		let mainElement = this._element.getElement('.main');;
		let mainWrapper = this._element.getElement('.main_nav_wrapper');
		let nav = this._element.getElement('.nav');
		let menuBuildings = nav.getElement('[data-sub-nav="4"');
		let menuInsights = nav.getElement('[data-sub-nav="5"');
		let subNavBuildings = this._element.getElement('.subnav-buildings');
		let subNavInsights = this._element.getElement('.subnav-insights');
		menuBuildings.addEvent('click', () => {
			subNavInsights.hide();
			subNavBuildings.show();
			mainElement.removeClass('menu-insights');
			mainElement.addClass('menu-buildings');
		});
		menuInsights.addEvent('click', () => {
			subNavBuildings.hide();
			subNavInsights.show();
			mainElement.removeClass('menu-buildings');
			mainElement.addClass('menu-insights');
		});

		this._element.addEvent('mouseleave', (e) => {
			subNavInsights.hide();
			subNavBuildings.hide();
			mainElement.removeClass('menu-buildings');
			mainElement.removeClass('menu-insights');
		});

	},

	add_scroll: function () {
		var winScroll = document.body.getScroll().y;
		var scrollShift = winScroll;
		var self = this;

		window.addEvents({
			'jumpStart': function () {
				self.isJumping = true;
			},
			'scroll': function () {

				let offsetElement = document.getElement(self.options.toggle_nav_element);
				let offset = 0;
				var scroll = document.body.getScroll().y;
				let toggleNavDown = false;
				let toggleNavUp = false;
				if (offsetElement) {
					offset = offsetElement.getBoundingClientRect().top + window.scrollY;
					toggleNavDown = scroll > winScroll && scroll >= offset
					toggleNavUp = scroll < winScroll && scroll < offset;
				} else {
					toggleNavDown = scroll > winScroll;
					toggleNavUp = scroll < winScroll;
				}
				if (toggleNavDown) {//scroll down
					scrollShift = scroll;
					if (!self.isDown && !self.isToggling && scroll > self.stalkerHeight) {
						self.isDown = true;
						document.fireEvent('hideSubMenu');
						self.toggle_persist_nav('down');
					}
				} else if (toggleNavUp) {//scroll up
					if (self.isDown) {
						if (!self.isJumping && !self.isToggling && (scrollShift - scroll > self.options.toggle_nav_delta) || scroll < self.stalkerHeight) {
							self.isDown = false;
							self.toggle_persist_nav('up');
							if (!!self.persist_nav) {
								self.persist_nav.setStyle('overflow', 'hidden');
							}
						}
					}
					if (self.options.double_nav && scroll < self.stalkerHeight) {
						self.persist_nav.setStyle('display', 'none');
					}

					// hide the menu just before reaching the top of the page
					if (scroll < 100) {
						self._element.removeClass('_up');
					} else {
						self._element.addClass('_up');
					}

				}
				winScroll = scroll;
				if (self.jump_links.length > 0) {
					self.refresh_DOM_height();
					self.set_active_jump_link();
				}
			},
			'jumpStop': function () {
				winScroll = document.body.getScroll().y;
				self.isJumping = false;
			},
		});
	},


	toggle_persist_nav: function (direction) {
		if ($(document.body).get('id') == 'bds') return;
		var self = this;
		let page_content_wrapper = null;
		if ($(document.body).get('id') == 'lst') page_content_wrapper = document.querySelector('.page_content_wrapper');

		if (direction === 'down') {
			self._element.addClass('_down');
			self._element.removeClass('_up');
			if (page_content_wrapper != null) page_content_wrapper.addClass('_down').removeClass('_up');
		} else if (direction === 'up') {
			self._element.addClass('_up');
			self._element.removeClass('_down');
			if (page_content_wrapper != null) page_content_wrapper.addClass('_up').removeClass('_down');
		}
	},

	adjust_side_bar: function () {
		if (this.visible) {
			this.side_bar.setStyle('top', this._element.getSize().y);
		}
	},

	refresh_DOM_height: function () {
		if (!this.DOM_height) {
			this.DOM_height = window.getScrollSize().y;
			this.refresh_targets();
		} else {
			var new_height = window.getScrollSize().y;
			if (this.DOM_height != new_height) {
				this.DOM_height = new_height;
				this.refresh_targets();
			}
		}
	},

	refresh_targets: function () {
		var self = this
		this.targets_top = {};
		this.jump_targets.each(function (_target) {
			self.targets_top[_target.get('name')] = _target.getPosition().y;
		});
	},

	set_active_jump_link: function () {
		var self = this;
		var scroll_pos = window.getScroll().y;

		Object.each(this.targets_top, function (value, key) {
			if (value < (scroll_pos + self.offset)) {
				self.jump_link = self.get_active_jump_link(key);
			}
		});

		if (!this.jump_link)
			return;

		if (this.active_jump_link) {
			this.active_jump_link.removeClass('_active');
		}

		this.active_jump_link = this.jump_link;
		this.active_jump_link.addClass('_active');

	},

	get_active_jump_link: function (href) {
		var active_link = null;

		this.jump_links.each(function (_link) {
			var href = _link.get('href');
			if (href && href.split('#')[1] === href) {
				active_link = _link;
				return;
			}
		})

		return active_link;
	},

	create_wrapper: function (_el) {
		var _wrapper = _el._wrapper = new Element('div', {
			'class': 'w_stalker_element_wrapper'
		});

		_wrapper.inject(_el, 'before').adopt(_el);
	},

	show_stalker: function () {
		if (this.visible) return;

		this.visible = true;

		this._stalkers.each(function (_el) {
			if (_el._wrapper) {
				_el._wrapper.setStyles({
					'overflow': 'auto'
				});

				_el._wrapper.setStyles({
					'min-height': (_el._wrapper.getElement('.serverside_sort') ? _el._wrapper.getElement('.serverside_sort').getSize().y : _el._wrapper.getSize().y),
					'overflow': 'visible'
				});
			}
		});

		this._walkers.each(function (_el) {
			_el.inject(this._container);

			if (_el.getElement('.advanced_tools_toggle') && _el.getElement('.advanced_tools.opened')) {
				_el.getElement('.advanced_tools_toggle').fireEvent('click');
			}
		}.bind(this));

		this._element.fade('in');
		this.fireEvent('show');
		this._element.fireEvent('show');
		document.fireEvent('hideSubMenu');

		if (this.side_bar) {
			this.adjust_side_bar();
		}

		if (this._header_members_notification) {
			this._header_members_notification.fade('out');
		}
	},

	hide_stalker: function () {
		if (!this.visible || this._element.hasClass('_visible')) return;

		this.visible = false;

		this._walkers.each(function (_el) {
			if (_el._wrapper) {
				_el._wrapper.setStyles({
					'min-height': 0
				});

				_el.inject(_el._wrapper);

				if (_el.getElement('.advanced_tools_toggle') && _el.getElement('.advanced_tools') && !_el.getElement('.advanced_tools').hasClass('opened')) {
					_el.getElement('.advanced_tools_toggle').fireEvent('click');
				}
			}
		});

		this._element.fade('out');
		this.fireEvent('hide');
		this._element.fireEvent('hide');
		document.fireEvent('hideSubMenu');

		if (this._header_members_notification) {
			this._header_members_notification.fade('in');
		}
	},

	add_stalker_thead: function (_thead) {
		if (!_thead) return;

		if ($(document.body).get('id') == 'bov') return;

		var _table = _thead.getParent('.w_divtable');

		if (!_table) return;

		this.create_wrapper(_thead);

		var _table_clone = _thead._stalker_table = _table.clone();
		_table_clone._thead = _thead;
		_table_clone.empty();

		this._container.adopt(_table_clone);

		var marker = _thead.getCoordinates().top;
		var markerEnd = _table.getCoordinates().bottom;

		var in_stalker = false;

		if (document.body.getScroll().y + this._element.getSize().y >= marker && document.body.getScroll().y + this._element.getSize().y <= markerEnd) {
			if (_thead._wrapper) {
				_thead._wrapper.setStyles({
					'overflow': 'auto'
				});

				_thead._wrapper.setStyles({
					'min-height': _thead._wrapper.getSize().y,
					'overflow': 'visible'
				});
			}

			in_stalker = true;
			_thead.inject(_table_clone);
		}

		var _tables = this._element.getElements('.w_divtable');

		_tables.each(function (_el, i) {
			if (i == 0) return;

			_el._thead._previous = _tables[i - 1]._thead;
		});

		window.addEvents({
			'scroll': function () {
				if (document.body.getScroll().y + this._element.getSize().y >= marker && document.body.getScroll().y + this._element.getSize().y <= markerEnd) {
					if (in_stalker) return;

					if (_thead._wrapper) {
						_thead._wrapper.setStyles({
							'overflow': 'auto'
						});

						_thead._wrapper.setStyles({
							'min-height': _thead._wrapper.getSize().y,
							'overflow': 'visible'
						});
					}

					_thead.inject(_table_clone);
					in_stalker = true;

					_tables.each(function (_el) {
						if (_el === _table_clone) {
							_thead.inject(_table_clone);
						} else {
							var _h = _el.getElement('.thead');
							_h.inject(_h._wrapper);
						}
					});
				} else {
					if (!in_stalker) return;

					if (_thead._wrapper) {
						_thead._wrapper.setStyles({
							'min-height': 0
						});
					}

					_thead.inject(_thead._wrapper);
					in_stalker = false;

					_tables.each(function (_el, i) {
						if (_el === _table_clone) {
							_thead.inject(_thead._wrapper);

							if (_el._thead._previous) {
								_el._thead._previous.inject(_el._thead._previous._stalker_table);
							}
						}
					});
				}
			}.bind(this)
		});
	},

	add_bubble: function (_title) {
		// CRTWO-2847
		if (_title.hasClass('bld_title')) {
			this._bubble = new Element('span.bubble', { 'html': 'Get more Info <span class="close">&times;</span>' });
			_title.adopt(this._bubble);
		}
	},

	add_inactive_message: function () {
		var _inactive_message = document.getElement('.inactive_message');

		if (!_inactive_message) {
			return;
		}

		var _cloned_inactive_message = _inactive_message.clone();
		this._container.adopt(_cloned_inactive_message);

		window.addEvents({
			'scroll': function () {
				if (document.body.getScroll().y < _inactive_message.getPosition().y + _inactive_message.getSize().y) {
					_cloned_inactive_message.hide();
				} else {
					_cloned_inactive_message.show();
				}
			}
		});
	},

	add_burger_menu_bldg: function () {
		let burger_icon = document.querySelector('.building_nav .burger-icon');
		let menu_ul = document.querySelector('.building_nav > ul');
		if (burger_icon && menu_ul) {
			// Toggle menu on burger icon click
			burger_icon.addEventListener('click', function () {
				burger_icon.classList.toggle('is-active');
				menu_ul.classList.toggle('opened');
			});

			// Remove classes when a <li> is clicked
			let menu_items = menu_ul.querySelectorAll('li');
			menu_items.forEach(function (item) {
				item.addEventListener('click', function () {
					burger_icon.classList.remove('is-active');
					menu_ul.classList.remove('opened');
				});
			});
		}
	}

});
